import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});

function isMobile() {
    return window.matchMedia("(max-width: 767.98px)").matches;
}

function buildLabelHtml(site) {
    if (site.target.substring(0, 3) == "url") {
        return `<a href="${site.target.replace('url:', '')}">${site.name}</a>`;
    }
    else {
        return `<a href="#${site.target}">${site.name}</a>`;
    }
    
}

function createMap(mapSelector, options = {}) {
    const mapEl =
        typeof mapSelector === "string"
            ? document.querySelector(mapSelector)
            : mapSelector;

    if (!mapEl) return null;

    const map = L.map(mapEl, {
        minZoom: options.minZoom ?? 10,
        maxZoom: options.maxZoom ?? 19,
        scrollWheelZoom: options.scrollWheelZoom ?? false
    }).setView(options.center ?? [45.572122, -122.708858], options.zoom ?? 11);

    // Always add the basemap first
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    if (options.tileUrl) {
        L.tileLayer(options.tileUrl, {
            attribution: options.attribution ?? '© <a href="http://www.portofportland.com">Port of Portland</a>',
            tms: options.tms ?? false,
            opacity: options.opacity ?? 1
        }).addTo(map);
    } 

    return map;
}

function createSiteLayer(sites, options = {}) {
    const markers = [];

    sites.forEach(site => {
        const marker = L.marker(site.coordinate);

        if (options.showPermanentLabels) {
            marker.bindTooltip(buildLabelHtml(site), {
                permanent: true,
                direction: "top",
                offset: [0, -8],
                interactive: true,
                className: "commercial-map-label"
            }).openTooltip();
        } else {
            marker.bindTooltip(site.name, {
                interactive: true,
                className: "commercial-map-label"
            });
        }

        if (site.popupContent) {
            marker.bindPopup(site.popupContent);
        }

        markers.push(marker);
    });

    return L.layerGroup(markers);
}

function normalizeSites(features) {
    return features.map(feature => ({
        name: feature.properties.name,
        target: feature.properties.target,
        coordinate: [
            feature.geometry.coordinates[1],
            feature.geometry.coordinates[0]
        ]
    }));
}

function initCommercialPropertiesMap(mapSelector, config = {}) {
    const {
        center = [45.572122, -122.708858],
        zoom = 11,
        minZoom = 10,
        maxZoom = 19,
        scrollWheelZoom = false,
        showPermanentLabels = true,
        tileUrl = null,
        geojsonFeatures = []
    } = config;

    const map = createMap(mapSelector, {
        center,
        zoom,
        minZoom,
        maxZoom,
        scrollWheelZoom,
        tileUrl
    });

    if (!map) return null;

    const sites = normalizeSites(geojsonFeatures);
    const layer = createSiteLayer(sites, { showPermanentLabels });

    layer.addTo(map);

    return map;
}

window.PortJS = window.PortJS || {};
window.PortJS.initCommercialPropertiesMap = initCommercialPropertiesMap;

export { initCommercialPropertiesMap };